import { render, staticRenderFns } from "./disabled.vue?vue&type=template&id=5bb974d0&"
import script from "./disabled.vue?vue&type=script&lang=js&"
export * from "./disabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports